<template>
    <div class="licensing-opportunity-playbook">
        <KeepAlive>
            <TargetCompanySelection
                v-if="currentStep.stepNum === 2"
                heading="Select Licensing Party"
                sub-heading="Search for a company that will be analyzed for licensing opportunities."
            />
        </KeepAlive>
        <LicensingOpportunitiesOutput v-if="currentStep.stepNum === 3" />
    </div>
</template>

<script setup>
import { ref, watch, onMounted, nextTick, computed } from 'vue'
import { usePlaybookGenerationStore } from '@/stores'
import { useRouter } from 'vue-router'

import TargetCompanySelection from '@/components/playbooks/shared/TargetCompanySelection.vue'
import LicensingOpportunitiesOutput from './LicensingOpportunitiesOutput.vue'

const playbookGenerationStore = usePlaybookGenerationStore()
const router = useRouter()

const updater = ref(0)
const source = ref(null)

onMounted(async () => {
    await nextTick()
})

watch(
    () => playbookGenerationStore.reportSelections,
    (newVal, oldVal) => {
        updater.value++
    },
    { deep: true }
)

watch(
    () => router,
    (newVal, oldVal) => {
        source.value = newVal.currentRoute.value.query.source
    },
    { flush: 'pre', immediate: true, deep: true }
)

const currentStep = computed(() => {
    return playbookGenerationStore.getCurrentStep()
})
</script>

<style lang="scss" scoped>
.licensing-opportunity-playbook {
    height: 100%;
    width: 100%;
}
</style>
